/**
 * Records each confirmed page view in the state of the area switch band.
 *
 * - The plugin must run after `10.getSectionRegistry.ts`. `recordPageView` needs the section registry.
 * - Vue Router calls `afterEach` only for the final destination of a navigation. A redirect in a global or
 *   page middleware does not call it for the page that redirects. It calls it for the target of the redirect.
 * - The Nuxt router plugin does the first navigation of a request before this plugin registers the hook. Nuxt
 *   does the first navigation again in the hook `app:created`, and the hook runs for this navigation. On the
 *   server this is before `app:rendered`, so `useCookie` still writes the `Set-Cookie` header.
 */
export default defineNuxtPlugin(() => {
    const router = useRouter();
    const { recordPageView } = useAreaSwitchBand();

    router.afterEach((to, _from, failure) => {
        if (failure) return;

        recordPageView(to);
    });
});
